import { LandingOverview } from '@services/landing/interfaces/landing.interfaces';

import { CATEGORIES_MOCK } from './categories.mock';

import { CDN_MOCKS_URL } from '@constants/constants';

export const MOCK_LANDING: LandingOverview = {
  productsToShow: [
    {
      id: '5a754ccb-bc5d-480d-82cb-26a92f94e810',
      name: 'Hello Kitty',
      basePrice: 10000,
      imageUrl: `${CDN_MOCKS_URL}Gemini_Generated_Image_u0gr5wu0gr5wu0grHelloKitty.png`,
      slug: 'hello-kitty-3d',
      position: 1,
    },
    {
      id: '9685de87-8a9e-45fd-ae8e-6a0869f99cd7',
      name: 'Bluey Articulado',
      basePrice: 8500,
      imageUrl: `${CDN_MOCKS_URL}Gemini_Generated_Image_u0gr5wu0gr5wu0grBluey.png`,
      slug: 'bluey-articulado',
      position: 2,
    },
    {
      id: 'c1d2e3f4-aaaa-bbbb-cccc-ddddeeee0001',
      name: 'Llavero de nombre',
      basePrice: 7000,
      imageUrl: `${CDN_MOCKS_URL}Gemini_Generated_Image_u0gr5wu0gr5wu0grKeynames.png`,
      slug: 'llavero-de-nombre',
      position: 3,
    },
  ],
  mainCategories: CATEGORIES_MOCK,
  plantProduct: {
    id: 'f7e8d9c0-1111-2222-3333-444455556666',
    name: 'Mandala con suculentas',
    basePrice: 15000,
    imageUrl: `${CDN_MOCKS_URL}mandala.png`,
    slug: 'mandala-con-suculentas',
  },
};
